import { Injectable } from '@angular/core';
/** Default values provider for typeahead */
export class TypeaheadConfig {
    constructor() {
        /** used to hide results on blur */
        this.hideResultsOnBlur = true;
        /** used to choose the first item in typeahead container */
        this.selectFirstItem = true;
        /** used to choose set minimal no of characters that needs to
           * be entered before typeahead kicks-in
           */
        this.minLength = 1;
    }
}
TypeaheadConfig.decorators = [
    { type: Injectable },
];
//# sourceMappingURL=typeahead.config.js.map